import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import cn from 'classnames';

export interface ILinkedInFollowProps extends IBaseElementProps {
	/**
	 * Use the company ID from LinkedIn here
	 */
	linkedInID: string;
}

const LinkedInFollow: React.FC<ILinkedInFollowProps> = ({
	id,
	className,
	classNames = [],
	linkedInID,
}) => {
	return (
		<div id={id} className={className || cn(...classNames)}>
			<script
				src="https://platform.linkedin.com/in.js"
				type="text/javascript"
			>
				lang: en_US
			</script>
			<script
				type="IN/FollowCompany"
				data-id={linkedInID}
				data-counter="bottom"
			></script>
		</div>
	);
};

export default LinkedInFollow;
